module.exports = __webpack_public_path__ + "img/bh.68f0d31d.svg";